module.exports = __webpack_public_path__ + "img/noPicUser.ec6ae432.png";